import React from 'react';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import './DonutChart.css';

ChartJS.register(ArcElement, Tooltip, Legend);

const DonutChart = ({ title, data, status }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'normal':
        return '#00C851';
      case 'warning':
        return '#FF8800';
      case 'critical':
        return '#FF4444';
      default:
        return '#B0B0B0';
    }
  };

  const chartData = {
    labels: ['Betriebsbereit', 'Warnung', 'Kritisch'],
    datasets: [
      {
        data: data || [85, 10, 5],
        backgroundColor: [
          '#00C851',
          '#FF8800',
          '#FF4444'
        ],
        borderColor: '#2A2A2A',
        borderWidth: 2,
        hoverOffset: 10
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: '70%',
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          color: '#FFFFFF',
          padding: 15,
          font: {
            size: 12
          }
        }
      },
      tooltip: {
        backgroundColor: '#2A2A2A',
        titleColor: '#00A8CC',
        bodyColor: '#FFFFFF',
        borderColor: '#00A8CC',
        borderWidth: 1,
        padding: 12,
        displayColors: true,
        callbacks: {
          label: function(context) {
            let label = context.label || '';
            if (label) {
              label += ': ';
            }
            label += context.parsed + '%';
            return label;
          }
        }
      }
    }
  };

  return (
    <div className="donut-chart-container">
      <h3 className="chart-title">{title || 'Status-Übersicht'}</h3>
      <div className="chart-wrapper">
        <Doughnut data={chartData} options={options} />
        <div className="chart-center-label">
          <div className="center-status" style={{ color: getStatusColor(status) }}>
            {status === 'normal' && 'OK'}
            {status === 'warning' && 'WARN'}
            {status === 'critical' && 'KRIT'}
          </div>
          <div className="center-subtitle">Status</div>
        </div>
      </div>
    </div>
  );
};

export default DonutChart;
